const ListPriceList = () => import('./ListPriceList.vue')
const EditPriceList = () => import('./EditPriceList.vue')
const NewPriceList = () => import('./NewPriceList.vue')
const TheContainer = () => import('@/containers/TheContainer')

export default [
    {
        path: '/priceListTemplate',
        name: 'priceListTemplate',
        component: TheContainer,
        meta: {
            perms: ['admin.price_list.list'],
            breadcrumb: {
                text: 'Price List Template',
                to: { name: 'priceListTemplate.list' }
            }
        },
        children: [
            {
                path: 'list',
                name: 'priceListTemplate.list',
                component: ListPriceList,
            },
            {
                path: 'new',
                name: 'priceListTemplate.new',
                component: NewPriceList,
                meta: {label: 'Create New',},
            },
            {
                path: ':id',
                name: 'priceListTemplate.edit',
                component: EditPriceList,
                meta: {label: 'Edit',},
            },
        ]
    }
]